import { Link, NavLink } from 'react-router-dom'
import type { ReactNode } from 'react'
import { LogOut } from 'lucide-react'
import { useAuth } from '@/features/auth/AuthContext'
import { Button } from '@/components/ui/button'

export function AppLayout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth()

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="bg-white border-b border-zinc-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="/star-logo.png" alt="STAR INSURANCE" className="h-9 w-auto" />
              <span className="hidden text-sm font-medium text-zinc-500 sm:inline">VINport</span>
            </Link>
            <nav className="hidden md:flex items-center gap-6 text-sm">
              <NavLink to="/" end className={navClass}>
                Vozový park
              </NavLink>
              <NavLink to="/history" className={navClass}>
                Historie
              </NavLink>
            </nav>
            <div className="flex items-center gap-3">
              {user && <span className="hidden sm:inline text-sm text-zinc-600">{user.email}</span>}
              <Button variant="ghost" size="sm" onClick={logout}>
                <LogOut className="h-4 w-4 mr-1" /> Odhlásit
              </Button>
            </div>
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  )
}

function navClass({ isActive }: { isActive: boolean }) {
  return isActive
    ? 'text-brand font-medium'
    : 'text-zinc-700 hover:text-zinc-900'
}
